import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import { FormattedMessage } from 'react-intl';
import { FEATURE_TOGGLES, useFeatureToggle } from '../../../../sharedComponents/FeatureToggle';
import PublicPageWrapper from './PublicPageWrapper';

const paperSx = {
  marginTop: 8,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  py: 2,
  px: 3,
  ml: {
    sx: 3,
    sm: 'auto',
  },
  mr: {
    sx: 3,
    sm: 'auto',
  },
  width: {
    sm: '400px',
  },
};

const PublicPageFormPaper = ({ children }) => {
  const foundation = useFeatureToggle(FEATURE_TOGGLES.FOUNDATION);

  return (
    <PublicPageWrapper>
      <CssBaseline />
      <Paper sx={paperSx}>
        <Box sx={{ width: '50%', display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ my: 5 }}>
            <Typography variant="h2">
              {foundation ? (
                <FormattedMessage id="general.gridos" defaultMessage="GridOS" />
              ) : (
                <FormattedMessage id="general.utilihive" defaultMessage="Utilihive" />
              )}
            </Typography>
          </Box>
        </Box>
        {children}
      </Paper>
    </PublicPageWrapper>
  );
};

export default PublicPageFormPaper;
